/**
 * SG PreSet chatflow plug-in — app boot imports `sg/preset` which pulls this in.
 */
import { registerChatFlow } from '../../../shared/preset/chatflows/chatFlowRegistry';
import { appointSecretaryFlow } from './appointSecretaryFlow';
import { appointDirectorFlow } from './appointDirectorFlow';
import { appointWithdrawDirectorFlow } from './appointWithdrawDirectorFlow';
import { changeFinancialYearEndFlow } from './changeFinancialYearEndFlow';
import { changeAddressFlow } from './changeAddressFlow';
import { withdrawDirectorFlow } from './withdrawDirectorFlow';
import { withdrawSecretaryFlow } from './withdrawSecretaryFlow';
import { agmUfsFlow } from './agmUfsFlow';
import { agmAfsFlow } from './agmAfsFlow';
import { agmExemptedAfsFlow } from './agmExemptedAfsFlow';
import { agmExemptedUfsFlow } from './agmExemptedUfsFlow';
import { allotmentSharesFlow } from './allotmentSharesFlow';
import { transferSharesFlow } from './transferSharesFlow';
import { shareCertificateFlow } from './shareCertificateFlow';
import { noticeIndividualControllerFlow } from './noticeIndividualControllerFlow';
import { noticeCorporateControllerFlow } from './noticeCorporateControllerFlow';
import { confirmationControllersFlow } from './confirmationControllersFlow';
import { incorporationPreFlow } from './incorporationPreFlow';
import { incorporationPostFlow } from './incorporationPostFlow';
import { finalDividendsFlow } from './finalDividendsFlow';
import { interimDividendsFlow } from './interimDividendsFlow';
import { appointWithdrawCeoFlow } from './appointWithdrawCeoFlow';
import { appointWithdrawMdFlow } from './appointWithdrawMdFlow';
import { appointDpoFlow } from './appointDpoFlow';

// 구체적 매칭 우선 — Incorporation (Post) before Pre name overlap
registerChatFlow(incorporationPostFlow);
registerChatFlow(incorporationPreFlow);
registerChatFlow(appointWithdrawMdFlow); // B32115 — Appoint / Withdraw MD ('director' 계열보다 먼저)
registerChatFlow(appointWithdrawCeoFlow); // B32114 — Appoint / Withdraw CEO (director 계열보다 먼저)
registerChatFlow(appointDpoFlow); // B32116 — Appointment of DPO (director 계열보다 먼저)
registerChatFlow(appointWithdrawDirectorFlow); // B32111 — appoint director 보다 먼저(구체 코드 매칭)
registerChatFlow(appointSecretaryFlow);
registerChatFlow(appointDirectorFlow);
registerChatFlow(changeFinancialYearEndFlow);
registerChatFlow(changeAddressFlow);
registerChatFlow(withdrawDirectorFlow);
registerChatFlow(withdrawSecretaryFlow);
registerChatFlow(agmExemptedAfsFlow);
registerChatFlow(agmExemptedUfsFlow);
registerChatFlow(agmAfsFlow);
registerChatFlow(agmUfsFlow);
registerChatFlow(allotmentSharesFlow);
registerChatFlow(transferSharesFlow);
registerChatFlow(shareCertificateFlow);
registerChatFlow(noticeIndividualControllerFlow);
registerChatFlow(noticeCorporateControllerFlow);
registerChatFlow(confirmationControllersFlow);
registerChatFlow(finalDividendsFlow); // B32112 — Final Dividends
registerChatFlow(interimDividendsFlow); // B32113 — Interim Dividends
